import React from "react";

const ProfileDetails = () => {
  return <div>ProfileDetails</div>;
};

export default ProfileDetails;
